function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamonds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 591.807 591.807",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.241 279.171c-6.268 9.85-6.234 23.668 0 33.464l168.663 265.042c11.993 18.846 36.015 18.832 47.999 0l168.663-265.042c6.268-9.85 6.234-23.668 0-33.464L319.903 14.129c-11.993-18.846-36.015-18.832-47.999 0L103.241 279.171zm276.077 65.855 14.552 9.26c4.157 2.646 5.329 7.994 2.757 12.035l-63.361 99.567c-2.56 4.023-7.976 5.205-12.07 2.6l-14.552-9.26c-4.157-2.646-5.329-7.994-2.757-12.035l63.361-99.567c2.56-4.023 7.975-5.205 12.07-2.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    fill: "#000000",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamonds);
export default __webpack_public_path__ + "static/media/diamonds.1498a76ba6b0cce7fe2d85cdb18b323d.svg";
export { ForwardRef as ReactComponent };